// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2813":"2a591b1962d42daf","2888":"6c32e82a42aa04e8"}[chunkId] + ".css";
};